import moment from 'moment';
import {
    USERHOURSLIST_PAGE,
    USERHOURSLIST_SEARCH,
    USERHOURSLIST_YEAR,
    USERHOURSLIST_PERIOD
} from '../actions/userhourslistactions';

const state = {
    search: '',
    page: 0,
    period: moment().month() + 1,
    year: moment().year(),
};

const getters = {
    page: state => state.page,
    search: state => state.search,
    period: state => state.period,
    year: state => state.year,
};

const actions = {
    [USERHOURSLIST_SEARCH]: ({ commit }, search) => {
        commit(USERHOURSLIST_SEARCH, search);
    },
    [USERHOURSLIST_PAGE]: ({ commit }, page) => {
        commit(USERHOURSLIST_PAGE, page);
    },
    [USERHOURSLIST_PERIOD]: ({ commit }, period) => {
        commit(USERHOURSLIST_PERIOD, period);
    },
    [USERHOURSLIST_YEAR]: ({ commit }, year) => {
        commit(USERHOURSLIST_YEAR, year);
    },
};

const mutations = {
    [USERHOURSLIST_SEARCH]: (state, search) => {
        state.page = 0;
        state.search = search;
    },
    [USERHOURSLIST_PAGE]: (state, page) => {
        state.page = page;
    },
    [USERHOURSLIST_PERIOD]: (state, period) => {
        state.page = 0;
        state.period = period;
    },
    [USERHOURSLIST_YEAR]: (state, year) => {
        state.page = 0;
        state.year = year;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};